import { render, staticRenderFns } from "./Pixelate.vue?vue&type=template&id=6ec1f0c5&"
import script from "./Pixelate.vue?vue&type=script&lang=ts&"
export * from "./Pixelate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports